import { GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummary200 } from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date';
import { ROUTES, replaceRouteParams } from '~/utils/routes';

type Args = {
  data: GetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdSummary200;
  stressAssessmentId: number;
};

type BreadcrumbItem = {
  label: string;
  href?: string;
};

type IConvertToBreadcrumbItems = (args: Args) => {
  items: BreadcrumbItem[];
};

export const convertToBreadcrumbItems: IConvertToBreadcrumbItems = ({
  data,
  stressAssessmentId,
}) => {
  const stressAssessment = data.stress_assessment_summary?.stress_assessment;
  const surveyDateLabel = stressAssessment?.survey_date
    ? formatDate({
        date: new Date(stressAssessment.survey_date * 1000),
        formatType: 'yyyy/M/d',
      })
    : 'レポート';

  const items: BreadcrumbItem[] = [
    { label: 'ストレスチェック', href: ROUTES.STRESS_ASSESSMENTS.INDEX },
    {
      label: surveyDateLabel,
      href: replaceRouteParams(ROUTES.STRESS_ASSESSMENTS.REPORTS, { id: stressAssessmentId }),
    },
    { label: '報告書作成ガイド' },
  ];

  return { items };
};
